var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('masonry',{attrs:{"cols":2,"gutter":10}},_vm._l((_vm.dataset),function(item,index){return _c('div',{key:index,attrs:{"data-cy":_vm.cyTest(index)},on:{"click":function($event){return _vm.selectedItem(index)}}},[_c('img',{staticClass:"img-box",attrs:{"src":_vm.getUrlFrom(item)}})])}),0)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }